<template>
  <div class="c-login">
    <el-card class="c-login__card"
             v-loading="isLoading">
      <div slot="header">
        <div class="c-login__logo-wrapper">
          <img
            class="c-login__logo"
            src="../../assets/britecore_logo.svg" />
        </div>
        <h3
          v-if="clientName"
          class="c-heading__sub u-text--center u-mt3 u-text--light custom-style__login-client-name">
          {{ clientName }}
        </h3>
      </div>

      <el-alert
        v-if="alert"
        class="u-mb3"
        :title="alert"
        type="info"
        closeable>
      </el-alert>

      <h4 class="c-heading__sub u-mb3 custom-style__login-header">{{ header }}</h4>
      <router-view
        :username.sync="username"
        :preferences="preferences"
        @update:preferences="updatePreferences"
        @submitting="submitting">
      </router-view>

    </el-card>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { get } from 'lodash'

  export default {
    data: function () {
      return {
        username: '',
        preferences: {
          rememberThisDevice: false
        }
      }
    },
    methods: {
      updatePreferences: function (preferenceUpdate) {
        this.preferences = Object.assign(this.preferences, preferenceUpdate)
      },
      submitting: function (submitting) {
        this.$store.commit('loading', submitting)
      }
    },
    computed: {
      ...mapGetters('authentication', [
        'isAuthenticating'
      ]),
      ...mapState('authentication', [
        'isAuthenticating'
      ]),
      ...mapState(['loading']),
      clientName () {
        return get(this, '$store.state.bcClassic.carrier.name')
      },
      isLoading () {
        return this.loading || this.isAuthenticating
      },
      header () {
        const defaultHeader = 'Sign in to BriteCore'
        return this.$route.meta.header || defaultHeader
      },
      alert () {
        return this.$route.meta.message
      }
    }
  }
</script>
